<template>
  <!-- 服务中心 -->
  <div class="g-cloudMarketBox">
    <div class="cloudMarket_leftBox">
      <div ref="searchBox" class="cloudMarket_leftBox_searchBox">
        <el-input v-model.trim="keyWord" placeholder="搜索关键词" maxlength="50" @focus="flag = true" @keyup.enter.native="getSearch()">
          <i slot="suffix" class="gp-input__icon el-icon-search pointer" @click="getSearch()" />
        </el-input>
        <div v-if="flag ===true" class="cloudMarket_leftBox_searchBox_searchRecords">
          <search :search-type="20039910" :search-list="serviceSearchList" :tab-type="4" @words="words" />
        </div>
      </div>
      <div class="cloudMarket_leftBox_menuss">
        <el-menu
          :default-active="activeitem"
          class="gp-menu-vertical-demo"
          @select="handleSelect"
        >
          <div v-for="(item,i) in classificationList" :key="i">
            <el-menu-item :index="''+i" class="cloudMarket_leftBox_menuss_comoncolor">
              <span slot="title">
                <UmToolTip :content="item.classifyName" />
              </span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>
    </div>
    <div class="cloudMarket_rightBox ">
      <banner :banner-list="bannerList" />
      <div v-if="menuId==='0'" class="cardBox-minH" :class="selectServicesList.length===0?'flex-center':''">
        <!--        <el-row v-if="selectServicesList.length>0" class="f-mg-t-46">-->
        <el-row v-if="selectServicesList.length>0" :gutter="20">
          <el-col v-for="(item,i) in selectServicesList" :key="i" :span="8">
            <!--            <application :type="4" :tab-type="4" :form="item" />-->
            <serveList :type="4" :tab-type="4" :form="item" class="cardBox mb20" />
          </el-col>
        </el-row>
        <div v-else style="padding:20px 0;width:100%">
          <no-data />
        </div>
      </div>
      <div v-else class="cardBox_paging cardBox-minH" :class="otherServicesList.length===0?'flex-center':''">
        <el-row v-if="otherServicesList.length>0" :gutter="20">
          <el-col v-for="(item,i) in otherServicesList" :key="i" :span="8">
            <!--            <application :type="4" :tab-type="4" :form="item" />-->
            <serveList :type="4" :tab-type="4" :form="item" class="cardBox mb20" />
          </el-col>
        </el-row>
        <no-data v-else />
        <div v-if="total>0">
          <div class="cloudMarket_rightBox_pages">
            <pagination
              :total="total"
              :page.sync="page.pageNum"
              :limit.sync="page.pageSize"
              :page-sizes="[30, 60, 90, 120]"
              @pagination="getOtherServices('page')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from '../components/search.vue'
// import application from '../components/application.vue'
import banner from '../components/banner.vue'
import { getBanner, getApplicationMenu, getSelectServices, getOtherServices } from '@/api/cloudMarket'
import noData from '../components/noData.vue'
import serveList from '@/views/cloudMarket/components/serveList'
export default {
  name: 'CloudMarketServiceCentre',
  components: { search, banner, noData, serveList },
  data() {
    return {
      activeitem: '0', // 侧边栏默认
      flag: false,
      bannerList: [],
      classificationList: [],
      selectServicesList: [],
      page: {
        pageSize: 30,
        pageNum: 1
      },
      total: 0,
      menuId: '0',
      typeId: null,
      keyWord: '',
      serviceSearchList: [],
      otherServicesList: [],
      hotList: []
    }
  },
  mounted() {
    this.getBanner()
    this.getApplicationMenu()
    this.getSelectServices()
    const key = 'serviceSearch_' + this.$store.getters.enterpriseUuid
    try {
      const redult = JSON.parse(window.localStorage.getItem(key))
      if (redult && Array.isArray(redult)) {
        this.serviceSearchList = redult
      } else {
        this.serviceSearchList = []
      }
    } catch {
      this.serviceSearchList = []
    }
  },
  created() {
    document.body.addEventListener('click', this.bodyClickhandler)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.bodyClickhandler)
  },
  methods: {
    // 点击搜索框关闭搜索框
    bodyClickhandler(event) {
      const _target = event.target
      if (this.$refs.searchBox) {
        if (this.$refs.searchBox.contains(_target)) {
          //
        } else {
          this.flag = false
        }
      }
    },
    words(val, hotList) {
      this.keyWord = val
      this.hotList = hotList
      this.getSearch()
    },
    getBanner() {
      getBanner({ bannerNo: '200912004-P' }).then(res => {
        this.bannerList = res.data
      })
    },
    // 获取应用菜单分类
    getApplicationMenu() {
      getApplicationMenu({ classifyCode: 2003010105 }).then(res => {
        this.classificationList = res.data.list
        this.classificationList.unshift({
          classifyUuid: null,
          classifyName: '精选'
        })
      })
    },
    // 精选服务
    getSelectServices() {
      const load = this.$load()
      this.selectServicesList = []
      getSelectServices({ page: { pageNum: 1, pageSize: 10 }}).then(res => {
        load.close()
        res.data.list.forEach(item => {
          let info = {}
          info = {
            appUuid: item.serviceUuid,
            appName: item.serviceTitle,
            appIconUrl: item.serviceIconUrl,
            appDescription: item.serviceDescribe,
            appPrice: item.servicePrice,
            specificationsCount: item.specificationsCount,
            saleNum: item.saleNum,
            visitNum: item.visitNum
          }
          this.selectServicesList.push(info)
        })
      }).catch(e => {
        load.close()
      })
    },
    // 其他服务
    getOtherServices(state = '') {
      if (state !== 'page') {
        this.page = {
          pageSize: 30,
          pageNum: 1
        }
      }
      const load = this.$load()
      const params = {
        serviceClassifyUuid: this.typeId,
        page: {
          pageSize: this.page.pageSize,
          pageNum: this.page.pageNum
        }
      }
      this.otherServicesList = []
      getOtherServices(params).then(res => {
        load.close()
        res.data.list.forEach(item => {
          let info = {}
          info = {
            appUuid: item.serviceUuid,
            appName: item.serviceTitle,
            appIconUrl: item.serviceIconUrl,
            appDescription: item.serviceDescribe,
            appPrice: item.servicePrice,
            specificationsCount: item.specificationsCount,
            saleNum: item.saleNum,
            visitNum: item.visitNum
          }
          this.otherServicesList.push(info)
        })
        this.total = res.data.page.total
        this.page = {
          pageSize: res.data.page.pageSize,
          pageNum: res.data.page.pageNum
        }
      }).catch(e => {
        load.close()
      })
    },
    handleSelect(val) {
      this.menuId = val
      if (val === '0') {
        this.getSelectServices()
      } else {
        this.typeId = this.classificationList[val].classifyUuid
        this.getOtherServices()
      }
    },
    getSearch() {
      if (this.keyWord) {
        // 存储
        const key = 'serviceSearch_' + this.$store.getters.enterpriseUuid
        this.serviceSearchList.unshift(this.keyWord)
        this.serviceSearchList = [...new Set(this.serviceSearchList)].splice(0, 5)
        window.localStorage.setItem(key, JSON.stringify(this.serviceSearchList))

        this.$router.push({ path: '/cloudMarket/search', query: { keyWord: this.keyWord, hotList: this.hotList, tabType: 4 }})
        this.keyWord = ''
      } else {
        this.$message.error('请输入搜索关键词')
      }
    }
  }
}
</script>

